import React, { useState, useEffect, useRef } from "react"
import { Navbar, Container, Nav, Dropdown, Offcanvas, Badge, Button, Overlay, Popover } from "react-bootstrap"
// Bootstrap icons
import { BsChatLeftFill, BsFillBellFill } from "react-icons/bs";

// Boxicons
import {
  BiUserCircle,
  BiX,
  BiChevronDown,
  BiHome,
  BiBook,
  BiCollection,
  BiLineChart,
  BiHeart,
  BiGroup,
  BiUser,
  BiNews,
  BiInfoCircle,
  BiLogOut,
} from "react-icons/bi";
import kaas from '../Images/Vetrina _Logo.png'
import { Link ,useNavigate, useLocation } from "react-router-dom" // Added useLocation
import axios from "axios"
import { motion, AnimatePresence } from "framer-motion"
import { BiMenu } from 'react-icons/bi';

function Header() {
  // State management
  const [notifications, setNotifications] = useState([])
  const [role, setRole] = useState(null)
  const [userName, setUserName] = useState("")
  const [profilePic, setProfilePic] = useState("")
  const [showMessages, setShowMessages] = useState(false)
  const [showOffcanvas, setShowOffcanvas] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeTab, setActiveTab] = useState("") // Added activeTab state

  // Refs for popovers
  const messageTarget = useRef(null)
  const navigate = useNavigate();
  const location = useLocation(); // Added useLocation hook

  // API URL
  const url = "https://kaasbackend.vetrinahealthcare.com/"
  const token = localStorage.getItem("jwttoken")

  // Fetch user data on component mount
  useEffect(() => {
    const storedRole = localStorage.getItem("role")
    setRole(storedRole)
    fetchUserName()
    fetchNotifications()

     // Add scroll event listener
    window.addEventListener("scroll", handleScroll)
    
    // Add resize event listener for mobile detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener("scroll", handleScroll)
      window.removeEventListener('resize', handleResize);
    }
  }, [])

  // Update active tab when location changes
  useEffect(() => {
    updateActiveTab();
  }, [location.pathname]);

  // Function to update active tab based on current path
  const updateActiveTab = () => {
    const path = location.pathname;
    
    // Map paths to tab names
    const pathToTabMap = {
      "/Home": "Home",
      "/CoursePage": "Explore Courses",
      "/courses": "My Courses", 
      "/membership": "Membership",
      "/memberpage": "Members",
      "/group": "Group",
      "/feeds": "Feeds",
      "/About": "About Us",
      "/wishlist": "Wishlist"
    };

    // Find the matching tab
    for (const [pathKey, tabName] of Object.entries(pathToTabMap)) {
      if (path === pathKey || path.startsWith(pathKey)) {
        setActiveTab(tabName);
        return;
      }
    }
    
    // Default if no match found
    setActiveTab("");
  }

  // Handle scroll for navbar background change
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true)
    } else {
      setScrolled(false)
    }
  }

  // Fetch user data
  const fetchUserName = async () => {
    if (!token) return;
    try {
      const response = await axios.get(`${url}lms/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      const data = response.data
      setUserName(`${data.first_name} ${data.last_name}`)
      setProfilePic(data.profile_pic)
       
    } catch (error) {
      console.error("Error fetching user name:", error)
    }
  }

  // Fetch notifications
  const fetchNotifications = async () => {
    if (!token) return;
    try {
      const response = await axios.get(`${url}socialapp/notifications/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      setNotifications(response.data.filter((notif) => notif.type === "message"))
    } catch (error) {
      console.error("Error fetching notifications:", error)
    }
  }

  const handleLogout = () => {
    // Clear all localStorage items
    localStorage.clear();
    
    // Alternatively, if you want to clear specific items only:
    //  localStorage.removeItem("jwttoken");
    // localStorage.removeItem("role");
    // localStorage.removeItem("userId");
    
    // Redirect to login page
    navigate("/Log");
    
    // Close offcanvas if open
    setShowOffcanvas(false);
  }

  // Animation variants for menu items
  const menuItemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.5,
        ease: "easeOut",
      },
    }),
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.3,
      },
    },
  }

  // Updated styles with active tab styling
  const styles = {
    navbarMain: {
      backgroundColor: 'rgba(253, 252, 252, 0.9)',
      padding: '0.5rem 1rem',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 1030,
      ...(scrolled && {
        backgroundColor: 'rgba(252, 251, 251, 0.95)',
        padding: '0.4rem 1rem',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      })
    },
    logo: {
      height: '36px',
      width: 'auto'
    },
    navLinkCustom: {
      color: 'rgb(7, 7, 7)',
      fontWeight: 500,
      padding: '0.5rem 0.75rem',
      margin: '0 0.25rem',
      position: 'relative',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      borderRadius: '0.375rem',
      ':hover': {
        color: 'rgb(8, 8, 8)',
        transform: 'translateY(-2px)',
        backgroundColor: 'rgba(147, 51, 234, 0.1)' // Light purple on hover
      }
    },
    navLinkActive: { // Added active tab style
      backgroundColor: 'rgb(147, 51, 234)', // Purple color
      color: 'white',
      fontWeight: 600,
      boxShadow: '0 4px 12px rgba(147, 51, 234, 0.3)',
      transform: 'translateY(-2px)'
    },
    navIcon: {
      fontSize: '1.25rem',
      marginRight: '0.25rem'
    },
    navItemWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    iconButton: {
      background: 'transparent',
      border: 'none',
      color: 'rgb(8, 8, 8)',
      padding: '0.5rem',
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    notificationBadge: {
      position: 'absolute',
      top: '-5px',
      right: '-5px',
      fontSize: '0.65rem',
      padding: '0.15rem 0.35rem'
    },
    userDropdownToggle: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      backgroundImage: 'none !important',
      '::after': { 
        display: 'none' 
      }
    },
    userAvatarWrapper: {
      display: 'flex',
      alignItems: 'center',
      padding: '0.25rem'
    },
    avatarContainer: {
      position: 'relative',
      display: 'inline-block'
    },
    userAvatar: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '2px solid #ffffff'
    },
    userAvatarPlaceholder: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: '#e0e0e0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#555555',
      border: '2px solid #ffffff'
    },
    dropdownArrow: {
      color: 'rgb(8,8,8)',
      marginLeft: '0.25rem',
      transition: 'transform 0.3s ease'
    },
    userDropdownMenu: {
      minWidth: '280px',
      padding: 0,
      borderRadius: '0.5rem',
      border: 'none',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
      marginTop: '0.75rem',
      overflow: 'hidden'
    },
    userInfo: {
      padding: '1rem',
      backgroundColor: '#f8f9fa'
    },
    userInfoAvatarContainer: {
      marginRight: '0.75rem'
    },
    userInfoAvatar: {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '2px solid #e9ecef'
    },
    userInfoAvatarPlaceholder: {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      backgroundColor: '#e0e0e0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#555555'
    },
    userInfoText: {
      display: 'flex',
      flexDirection: 'column'
    },
    userName: {
      fontWeight: 600,
      fontSize: '1rem',
      color: '#212529'
    },
    userHandle: {
      fontSize: '0.8rem',
      color: '#6c757d'
    },
    userRole: {
      fontSize: '0.75rem',
      color: '#007bff',
      marginTop: '2px',
      fontWeight: 500
    },
    dropdownItemCustom: {
      padding: '0.75rem 1rem',
      display: 'flex',
      alignItems: 'center',
      transition: 'all 0.2s ease',
      color: '#333',
      textDecoration: 'none',
      ':hover': {
        backgroundColor: '#e9ecef',
        color: '#000',
        transform: 'translateX(3px)'
      }
    },
    dropdownItemIcon: {
      marginRight: '0.75rem',
      fontSize: '1.1rem',
      color: '#555'
    },
    dropdownItemDanger: {
      color: '#dc3545',
      ':hover': {
        backgroundColor: '#fdf1f2',
        color: '#c82333'
      }
    },
    activeIndicator: {
      position: 'absolute',
      backgroundColor: '#28a745',
      borderRadius: '50%',
      zIndex: 1
    },
    messagesPopover: {
      maxWidth: '350px',
      border: 'none',
      borderRadius: '0.5rem',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
      fontSize: '0.9rem'
    },
    popoverHeader: {
      backgroundColor: 'rgb(12, 13, 14)',
      color: 'white',
      borderBottom: '1px solid #e9ecef',
      padding: '0.75rem 1rem',
      fontWeight: 600,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    closeBtn: {
      color: 'white',
      opacity: 0.8,
      padding: 0,
      ':hover': {
        opacity: 1
      }
    },
    messageItem: {
      padding: '0.75rem 1rem',
      borderBottom: '1px solid #e9ecef',
      display: 'block',
      color: '#212529',
      textDecoration: 'none',
      transition: 'background-color 0.2s ease',
      ':last-child': {
        borderBottom: 'none'
      },
      ':hover': {
        backgroundColor: '#f8f9fa'
      }
    },
    messageContent: {
      display: 'flex',
      flexDirection: 'column'
    },
    messageText: {
      fontSize: '0.875rem',
      marginBottom: '0.25rem',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    messageTime: {
      fontSize: '0.75rem',
      color: '#6c757d',
      alignSelf: 'flex-end'
    },
    viewAllLink: {
      display: 'block',
      padding: '0.5rem 1rem',
      color: '#007bff',
      textDecoration: 'none',
      fontSize: '0.875rem',
      fontWeight: 500,
      transition: 'all 0.2s ease',
      textAlign: 'center',
      borderTop: '1px solid #e9ecef',
      marginTop: '0.5rem',
      ':hover': {
        backgroundColor: '#f8f9fa',
        color: '#0056b3'
      }
    },
    mobileOffcanvas: {
      width: '85%',
      maxWidth: '320px',
      backgroundColor: '#ffffff',
      borderLeft: '1px solid #e9ecef'
    },
    offcanvasLogo: {
      height: '32px',
      width: 'auto'
    },
    offcanvasUserSection: {
      padding: '1rem',
      backgroundColor: '#f8f9fa',
      margin: '-1rem -1rem 1rem -1rem'
    },
    offcanvasAvatarContainer: {
      marginRight: '0.75rem'
    },
    offcanvasUserAvatar: {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '2px solid #e0e0e0'
    },
    offcanvasUserAvatarPlaceholder: {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      backgroundColor: '#e0e0e0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#555555'
    },
    offcanvasUserInfo: {
      display: 'flex',
      flexDirection: 'column'
    },
    offcanvasUserName: {
      fontWeight: 600,
      fontSize: '1rem',
      color: '#212529'
    },
    offcanvasUserHandle: {
      fontSize: '0.8rem',
      color: '#6c757d'
    },
    offcanvasUserRole: {
      fontSize: '0.75rem',
      color: '#007bff',
      marginTop: '2px',
      fontWeight: 500
    },
    offcanvasProfileLink: {
      display: 'block',
      marginTop: '0.75rem',
      padding: '0.6rem 1rem',
      backgroundColor: '#e9ecef',
      color: '#343a40',
      textDecoration: 'none',
      borderRadius: '0.3rem',
      fontSize: '0.875rem',
      fontWeight: 500,
      transition: 'all 0.2s ease',
      textAlign: 'center',
      ':hover': {
        backgroundColor: '#dee2e6',
        color: '#212529'
      }
    },
    offcanvasDivider: {
      height: '1px',
      backgroundColor: '#e9ecef',
      margin: '1rem 0'
    },
    offcanvasNav: {
      marginBottom: '1rem'
    },
    offcanvasNavLink: {
      padding: '0.75rem 1rem',
      color: '#212529',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '0.5rem',
      transition: 'all 0.2s ease',
      marginBottom: '0.25rem',
      textDecoration: 'none',
      ':hover': {
        backgroundColor: '#f1f3f5',
        transform: 'translateX(5px)'
      }
    },
    offcanvasNavLinkActive: { // Added active style for mobile
      backgroundColor: 'rgb(147, 51, 234)',
      color: 'white',
      fontWeight: 600,
      boxShadow: '0 4px 12px rgba(147, 51, 234, 0.3)',
    },
    offcanvasFooter: {
      padding: '1rem 0'
    },
    offcanvasLogoutButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      padding: '0.75rem',
      backgroundColor: '#fdf1f2',
      color: '#dc3545',
      borderRadius: '0.5rem',
      textDecoration: 'none',
      fontWeight: 500,
      transition: 'all 0.2s ease',
      ':hover': {
        backgroundColor: '#f8d7da',
        color: '#c82333'
      }
    },
    navbarToggler: {
      border: 'none',
      padding: '0.25rem 0.5rem',
      fontSize: '1.5rem',
      color: 'rgb(7, 7, 7)',
      background: 'transparent'
    }
    
  };

  // Navigation items - Filtering out Members for Student role
  const getNavItems = () => {
    const allNavItems = [
      // { name: "Home", path: "/Home", icon: <BiHome style={styles.navIcon} /> },
      { name: "Explore Courses", path: "/CoursePage", icon: <BiBook style={styles.navIcon} /> },
      // { name: "My Courses", path: "/courses", icon: <BiCollection style={styles.navIcon} /> },
      ...(role == "Student" ? [{ name: "Membership", path: "/membership", icon: <BiLineChart style={styles.navIcon} />}] :[]),
      ...(role !== "Student" ? [{ name: "Members", path: "/memberpage", icon: <BiUser style={styles.navIcon} /> }] : []),
      { name: "Group", path: "/group", icon: <BiGroup style={styles.navIcon} /> },
      { name: "Feeds", path: "/feeds", icon: <BiNews style={styles.navIcon} /> },
      { name: "About Us", path: "/About", icon: <BiInfoCircle style={styles.navIcon} /> },
    ];
    
    return allNavItems;
  }

  const navItems = getNavItems();

  return (
    <>
      <Navbar 
        expand="lg" 
        style={styles.navbarMain}
        expanded={expanded}
        onToggle={(isExpanded) => setExpanded(isExpanded)}
      >
        <Container fluid>
          {/* Logo */}
          <Navbar.Brand as={Link} to="/Home" style={{ display: 'flex', alignItems: 'center' }}>
            <motion.img
              src={kaas}
              style={styles.logo}
              alt="Kaas Logo"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            />
          </Navbar.Brand>

          {/* Mobile Toggle Button */}
     <motion.button
            style={{
              border: 'none',
              padding: '0.25rem 0.5rem',
              fontSize: '1.5rem',
              color: 'rgb(7, 7, 7)',
              background: 'transparent',
              marginLeft: 'auto',
              display: 'flex',
              alignItems: 'center',
              zIndex: 1050
            }}
            type="button"
            onClick={() => setShowOffcanvas(!showOffcanvas)}
            aria-controls="responsive-navbar-nav"
            aria-expanded={showOffcanvas}
            aria-label="Toggle navigation"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="d-lg-none" // Only show on mobile
          >
            {showOffcanvas ? <BiX size={24} /> : <BiMenu size={24} />}
          </motion.button>
          
          {/* Desktop Navigation */}
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav style={{ marginLeft: 'auto', alignItems: 'center' }}>
              {/* Desktop Nav Items */}
              {navItems.map((item, index) => (
                <motion.div
                  key={item.name}
                  custom={index}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  variants={menuItemVariants}
                  style={styles.navItemWrapper}
                >
                  <Nav.Link 
                    as={Link} 
                    to={item.path} 
                    style={{
                      ...styles.navLinkCustom,
                      ...(activeTab === item.name && styles.navLinkActive)
                    }}
                  >
                    {item.name}
                  </Nav.Link>
                </motion.div>
              ))}

              {/* Wishlist for Students */}
              {role === "Student" && (
                <motion.div
                  custom={navItems.length}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  variants={menuItemVariants}
                  style={styles.navItemWrapper}
                >
                  <Nav.Link 
                    as={Link} 
                    to="/wishlist" 
                    style={{
                      ...styles.navLinkCustom,
                      ...(activeTab === "Wishlist" && styles.navLinkActive)
                    }}
                  >
                    <BiHeart style={styles.navIcon} /> Wishlist
                  </Nav.Link>
                </motion.div>
              )}

              {/* Messages */}
              <motion.div
                custom={navItems.length + (role === "Student" ? 1 : 0)}
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={menuItemVariants}
                style={styles.navItemWrapper}
              >
                <div ref={messageTarget}>
                  <motion.button
                    style={styles.iconButton}
                    onClick={() => setShowMessages(!showMessages)}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <BsFillBellFill style={styles.navIcon} />
                    {notifications.length > 0 && (
                      <Badge pill bg="danger" style={styles.notificationBadge}>
                        {notifications.length}
                      </Badge>
                    )}
                  </motion.button>
                </div>

                <Overlay
                  show={showMessages}
                  target={messageTarget.current}
                  placement="bottom-end"
                  container={document.body}
                  rootClose
                  onHide={() => setShowMessages(false)}
                >
                  <Popover id="popover-messages" style={styles.messagesPopover}>
                    <Popover.Header as="h3" style={styles.popoverHeader}>
                      Messages
                      <Button variant="link" style={styles.closeBtn} onClick={() => setShowMessages(false)}>
                        <BiX size={20} />
                      </Button>
                    </Popover.Header>
                    <Popover.Body style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      <AnimatePresence>
                        {notifications.length > 0 ? (
                          notifications.map((msg, index) => (
                            <motion.div
                              key={msg.id}
                              initial={{ opacity: 0, y: 10 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: -10 }}
                              transition={{ delay: index * 0.05 }}
                            >
                              <Link
                                to={`/textmessage/${msg.id}`}
                                style={styles.messageItem}
                                onClick={() => setShowMessages(false)}
                              >
                                <div style={styles.messageContent}>
                                  <div style={styles.messageText}>{msg.message}</div>
                                  <div style={styles.messageTime}>
                                    {new Date(msg.created_at).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })}
                                  </div>
                                </div>
                              </Link>
                            </motion.div>
                          ))
                        ) : (
                          <motion.p
                            style={{ color: '#6c757d', textAlign: 'center', padding: '0.75rem 0' }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                          >
                            No new messages
                          </motion.p>
                        )}
                      </AnimatePresence>

                      {notifications.length > 0 && (
                        <motion.div
                          style={{ textAlign: 'center', marginTop: '0.5rem' }}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ delay: 0.3 }}
                        >
                          <Link to="/lmsmessage" style={styles.viewAllLink} onClick={() => setShowMessages(false)}>
                            View all messages
                          </Link>
                        </motion.div>
                      )}
                    </Popover.Body>
                  </Popover>
                </Overlay>
              </motion.div>

              {/* User Profile Dropdown */}
              <motion.div
                custom={navItems.length + (role === "Student" ? 1 : 0) + 1}
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={menuItemVariants}
                style={styles.navItemWrapper}
              >
                <Dropdown align="end">
                  <Dropdown.Toggle 
                    as="div" 
                    id="dropdown-user" 
                    style={styles.userDropdownToggle}
                  >
                    <motion.div 
                      style={styles.userAvatarWrapper} 
                      whileHover={{ scale: 1.1 }} 
                      whileTap={{ scale: 0.9 }}
                    >
                      <div style={styles.avatarContainer}>
                        {profilePic ? (
                          <img 
                            src={profilePic} 
                            alt="Profile" 
                            style={styles.userAvatar} 
                          />
                        ) : (
                          <div style={styles.userAvatarPlaceholder}>
                            <BiUserCircle size={24} />
                          </div>
                        )}
                        <span style={{ 
                          ...styles.activeIndicator, 
                          width: '10px',
                          height: '10px',
                          bottom: '2px',
                          right: '2px',
                          border: '1.5px solid white'
                        }}></span>
                      </div>
                    </motion.div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={styles.userDropdownMenu}>
                    <div style={styles.userInfo}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ 
                          ...styles.avatarContainer, 
                          ...styles.userInfoAvatarContainer 
                        }}>
                          {profilePic ? (
                            <img 
                              src={profilePic} 
                              alt="Profile" 
                              style={styles.userInfoAvatar} 
                            />
                          ) : (
                            <div style={styles.userInfoAvatarPlaceholder}>
                              <BiUserCircle size={36} />
                            </div>
                          )}
                          <span style={{ 
                            ...styles.activeIndicator, 
                            width: '12px',
                            height: '12px',
                            bottom: '3px',
                            right: '3px',
                            border: '2px solid #f8f9fa'
                          }}></span>
                        </div>
                        <div style={styles.userInfoText}>
                          <div style={styles.userName}>{userName || "User"}</div>
                          <div style={styles.userHandle}>@{userName ? userName.toLowerCase().replace(/\s+/g, "_") : "user_handle"}</div>
                          {role && <div style={styles.userRole}>Role: {role}</div>}
                        </div>
                      </div>
                    </div>

                    <Dropdown.Divider />

                    <Dropdown.Item as={Link} to="/profilenew" style={styles.dropdownItemCustom}>
                      <BiUser style={styles.dropdownItemIcon} />
                      Profile
                    </Dropdown.Item>

                    <Dropdown.Divider />

                        <Dropdown.Item
      onClick={handleLogout}
      style={{
        ...styles.dropdownItemCustom,
        ...styles.dropdownItemDanger,
      }}
    >
      <BiLogOut style={styles.dropdownItemIcon} />
      Log Out
    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </motion.div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Mobile Offcanvas Menu */}
      <Offcanvas 
        show={showOffcanvas} 
        onHide={() => setShowOffcanvas(false)} 
        placement="end" 
        style={styles.mobileOffcanvas}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img 
              src={kaas} 
              alt="Kaas Logo" 
              style={styles.offcanvasLogo} 
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* User Profile Section */}
          <div style={styles.offcanvasUserSection}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ 
                ...styles.avatarContainer, 
                ...styles.offcanvasAvatarContainer 
              }}>
                {profilePic ? (
                  <img 
                    src={profilePic} 
                    alt="Profile" 
                    style={styles.offcanvasUserAvatar} 
                  />
                ) : (
                  <div style={styles.offcanvasUserAvatarPlaceholder}>
                    <BiUserCircle size={40} />
                  </div>
                )}
                <span style={{ 
                  ...styles.activeIndicator, 
                  width: '12px',
                  height: '12px',
                  bottom: '3px',
                  right: '3px',
                  border: '2px solid #f8f9fa'
                }}></span>
              </div>
              <div style={styles.offcanvasUserInfo}>
                <div style={styles.offcanvasUserName}>{userName || "User"}</div>
                <div style={styles.offcanvasUserHandle}>@{userName ? userName.toLowerCase().replace(/\s+/g, "_") : "user_handle"}</div>
                {role && <div style={styles.offcanvasUserRole}>Role: {role}</div>}
              </div>
            </div>
            <Link 
              to="/profilenew" 
              style={styles.offcanvasProfileLink} 
              onClick={() => setShowOffcanvas(false)}
            >
              View Profile
            </Link>
          </div>

          <div style={styles.offcanvasDivider} />

          {/* Navigation Links */}
          <Nav style={{ flexDirection: 'column', ...styles.offcanvasNav }}>
            <AnimatePresence>
              {navItems.map((item, index) => (
                <motion.div
                  key={item.name}
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -50 }}
                  transition={{ delay: index * 0.05, duration: 0.3 }}
                >
                  <Nav.Link 
                    as={Link} 
                    to={item.path} 
                    style={{
                      ...styles.offcanvasNavLink,
                      ...(activeTab === item.name && styles.offcanvasNavLinkActive)
                    }} 
                    onClick={() => setShowOffcanvas(false)}
                  >
                    {item.icon}
                    <span>{item.name}</span>
                  </Nav.Link>
                </motion.div>
              ))}

              {/* Wishlist for Students */}
              {role === "Student" && (
                <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -50 }}
                  transition={{ delay: navItems.length * 0.05, duration: 0.3 }}
                >
                  <Nav.Link 
                    as={Link} 
                    to="/wishlist" 
                    style={{
                      ...styles.offcanvasNavLink,
                      ...(activeTab === "Wishlist" && styles.offcanvasNavLinkActive)
                    }} 
                    onClick={() => setShowOffcanvas(false)}
                  >
                    <BiHeart style={styles.navIcon} />
                    <span>Wishlist</span>
                  </Nav.Link>
                </motion.div>
              )}
            </AnimatePresence>
          </Nav>

          <div style={styles.offcanvasDivider} />

          {/* Logout Button */}
           <div style={styles.offcanvasFooter}>
            <button 
              onClick={handleLogout} 
              style={styles.offcanvasLogoutButton}
            >
              <BiLogOut style={{ marginRight: '0.5rem' }} />
              Log Out
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Header